import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";
import { isDesktop } from "react-device-detect";
// import moment from "moment";

import { Modal } from "react-responsive-modal";
import QuotaDeposit from "./QuotaDeposit";
import DepositHistory from "./DepositHistory";
import MobileDelegateDeposit from "./MobileDelegateDeposit";
import SideBar from "../../components/Sidebar/Sidebar";
// import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";

// import { Accordion, TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'

import * as actions from "../../store/ducks/delegateDeposit/actions";

class DelegateDeposit extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            pageShow: "quota_deposit",
            showModal: false,
            initialLoading: 
            [
                { id: "quota_deposit", loading: true },
                { id: "deposit_history", loading: true },
            ],
        };
        this.props.initDelegateDepositInitialLoading(this.state.initialLoading);
    }

    changeTabHandler = (e) => 
    {
        e.preventDefault();
        // console.log(e.target.id);
        this.setState({
            pageShow: e.target.id,
        });
    }

    toggleModal = () => 
    {
        this.setState({
            showModal: !this.state.showModal,
        });
    }

    redirectHandler = (page) => 
    {
        this.setState({
            pageShow: page,
        });
    }

    render() 
    {
        const { t } = this.props;
        const fadeUp = keyframes`
            from {
                opacity: 0;
                transform: translate3d(0, 50px ,0);
            }

            to {
                opacity: 1;
                transform: translate3d(0, 0, 0);
            }
        `;

        return (
            <>
            <Modal open={this.state.showModal} onClose={this.toggleModal} classNames={{ modal: "pd-edit-modal" }} center>
                <div className={!isDesktop ? "modal-content edit" : "edit"}>
                <div className="modal-header">
                    <h4 className="modal-title">{t('delegate-deposit.tips')}</h4>
                </div>
                <div className="modal-body">
                    <h6 className="text-dark mb-0">What is proxy storage?</h6>
                    <p className="mb-3">
                        Deposit is a new deposit method, which can participate in website discounts, and calculate the first
                        deposit and active; after deposit, the amount is directly deposited into the central wallet of its
                        subordinate members.
                    </p>
                    <h6 className="text-dark mb-0">What is Quota deposit?</h6>
                    <p>
                        When the balance in the commission wallet is not enough, the agent can deposit on behalf of the agent
                        through the deposit amount, which is allocated by the platform administrator. If the amount is not
                        enough, the agent can contact the administrator to apply.
                    </p>

                    {isDesktop && (
                        <button className="btn btn-gradient-blue w-50 d-block mx-auto mt-4" onClick={this.toggleModal}>
                            {t('global.ok')}
                        </button>
                    )}
                </div>
                {!isDesktop && (
                    <div class="modal-footer" onClick={this.toggleModal}>
                        <button className="btn modal-btn-confirm ">{t('global.ok')}</button>
                    </div>
                )}
                </div>

                {!isDesktop && (
                    <div className="modal-m-close-btn" onClick={this.toggleModal}>
                        <p className="modal-close-btn">{t('global.close')}</p>
                    </div>
                )}
            </Modal>
            
            {isDesktop ? (
                <section className="pf-dashboard">
                    <div className="x-container">
                        <SideBar />
                        <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="pd-card-col h-100">
                                        <div className="pd-header mb-3">
                                            <h4 className="mb-0">{t('sidebar.delegate-deposit')}</h4>
                                            <button className="btn">
                                                <Icon icon="material-symbols:info" onClick={this.toggleModal} />
                                            </button>
                                        </div>
                                        <div className="pd-content">
                                            <div className="fd-col">
                                                <ul className="nav nav-tabs" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${this.state.pageShow === "quota_deposit" ? 'active' : ''}`}
                                                            id="quota_deposit"
                                                            data-bs-toggle="tab"
                                                            data-bs-target="#quota-deposit"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="quota-deposit"
                                                            aria-selected="true"
                                                            onClick={(event) => this.changeTabHandler(event)}
                                                        >
                                                            {t('delegate-deposit.quota-deposit')}
                                                        </button>
                                                    </li>

                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${this.state.pageShow === "deposit_history" ? 'active' : ''}`}
                                                            id="deposit_history"
                                                            data-bs-toggle="tab"
                                                            data-bs-target="#deposit-history"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="deposit-history"
                                                            aria-selected="false"
                                                            onClick={(event) => this.changeTabHandler(event)}
                                                        >
                                                            {t('delegate-deposit.deposit-history')}
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="tab-content">
                                                {this.state.pageShow === "quota_deposit" && <QuotaDeposit redirectHandler={this.redirectHandler}/>}
                                                {this.state.pageShow === "deposit_history" && <DepositHistory />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </section>
            ) : (
                <MobileDelegateDeposit
                    {...this.state}
                    {...this.props}
                    changeTabHandler={this.changeTabHandler}
                    toggleModal={this.toggleModal}
                    redirectHandler={this.redirectHandler}
                />
            )}
            </>
        );
    }
}

const mapStateToProps = (state) => 
{
    return {};
};

const mapDispatchToProps = (dispatch) => 
{
    return {
        initDelegateDepositInitialLoading: (data) => dispatch(actions.initDelegateDepositInitialLoading(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(DelegateDeposit));